// StoreMap.js
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, SectionSquare } from "./styles";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import "material-symbols";
import api from "../../services/api";

function StoreMap() {
  const businessUnitCodeURL = new URLSearchParams(useLocation().search).get(
    "businessUnitCode"
  ); // Pegar o businessUnitCode da URL

  const navigate = useNavigate();

  function handleRowClick(business_unit_code, section) {
    navigate(`/esls?businessUnitCode=${business_unit_code}&section=${section}`);
  }

  const [infosSections, setInfosSections] = useState([]);

  useEffect(() => {
    api.get(`/esls/dataSection/${businessUnitCodeURL}`).then((response) => {
      setInfosSections(response.data);
    });
  }, [businessUnitCodeURL]);

  return (
    <Container>
      <h3 className="d-flex align-items-left">Mapa de Seções</h3>

      <MDBRow>
        {infosSections?.map((info) => (
          <MDBCol md="3">
            <SectionSquare
              onClick={() =>
                handleRowClick(info.businessUnitCode, info.section)
              }
            >
              <MDBRow>
                <h5
                  className="d-flex align-items-center"
                  style={{ display: "flex" }}
                >
                  <strong>Seção: {info.section}</strong>
                </h5>
              </MDBRow>
              <MDBRow>
                <p
                  className="d-flex align-items-center"
                  style={{ display: "flex" }}
                >
                  <span className="material-symbols-outlined">123</span>{" "}
                  <strong style={{ marginRight: "5px" }}>Instaladas:</strong>
                  {info.totalESLs} ESLs
                </p>
              </MDBRow>
              <MDBRow>
                <p
                  className="d-flex align-items-center"
                  style={{ display: "flex" }}
                >
                  <span
                    className="material-symbols-outlined"
                    style={{ marginRight: "5px" }}
                  >
                    link
                  </span>{" "}
                  <strong style={{ marginRight: "5px" }}>Comissionadas:</strong>
                  {info.totalESLs - info.notCommissionedESLs} ESLs
                </p>
              </MDBRow>
              <MDBRow>
                <p
                  className="d-flex align-items-center"
                  style={{ display: "flex" }}
                >
                  <span
                    className="material-symbols-outlined"
                    style={{ marginRight: "5px" }}
                  >
                    link_off
                  </span>{" "}
                  <strong style={{ marginRight: "5px" }}>
                    Não comissionadas:
                  </strong>
                  {info.notCommissionedESLs} ESLs
                </p>
              </MDBRow>
              <MDBRow>
                <p
                  className="d-flex align-items-center"
                  style={{ display: "flex" }}
                >
                  <span
                    className="material-symbols-outlined"
                    style={{ marginRight: "5px" }}
                  >
                    favorite
                  </span>{" "}
                  <strong style={{ marginRight: "5px" }}>Com conexão:</strong>{" "}
                  {info.isAliveESLs} ESLs ({info.isAliveESLsPercentage}%)
                </p>
              </MDBRow>
              <MDBRow>
                <p
                  className="d-flex align-items-center"
                  style={{ display: "flex" }}
                >
                  <span
                    className="material-symbols-outlined"
                    style={{ marginRight: "5px" }}
                  >
                    heart_broken
                  </span>{" "}
                  <strong style={{ marginRight: "5px" }}>Sem conexão:</strong>{" "}
                  {info.isntAliveESLs} ESLs
                </p>
              </MDBRow>
            </SectionSquare>
          </MDBCol>
        ))}
      </MDBRow>
    </Container>
  );
}

export default StoreMap;
